<template>
  <div class="time-display">
    <div v-if="['equal', 'begin', 'end'].includes(condition.regionType)" class="time-point">
      <span class="condition-name">{{ condition.name }}</span>
      <span class="condition-region">
        {{ regionTypeMap[condition.regionType] }}
      </span>
      <date-popover
        v-if="['半年度', '季度'].includes(condition.timeType)"
        :date="timeQuery.time"
        placeholder="选择时间"
        @change="changeTimeQuery('point', $event)"
        :time-type="condition.timeType"
        :class="{ 'required-hint': !result }"
      ></date-popover>
      <el-date-picker
        v-else
        v-model="timeQuery.time"
        clearable
        placeholder="选择时间"
        :type="dateTimePicker.type"
        :value-format="dateTimePicker.valueFormat"
        :format="dateTimePicker.displayFormat"
        :class="{ 'required-hint': !result }"
      ></el-date-picker>
      <div class="operation">
        <base-button
          icon="el-icon-arrow-left"
          class="left"
          @click="changeTime('last')"
        ></base-button>
        <base-button
          icon="el-icon-arrow-right"
          class="right"
          @click="changeTime('next')"
        ></base-button>
      </div>
    </div>
    <div v-else-if="condition.regionType === 'interval'" class="interval">
      <span class="condition-name">{{ condition.name }}</span>
      <div style="display: flex; align-items: center">
        <date-popover
          v-if="['半年度', '季度'].includes(condition.timeType)"
          :date="timeQuery.beginTime"
          placeholder="选择开始时间"
          @change="changeTimeQuery('beginTime', $event)"
          :time-type="condition.timeType"
          :class="{ 'required-hint': !result }"
        ></date-popover>
        <el-date-picker
          v-else
          v-model="timeQuery.beginTime"
          clearable
          placeholder="选择开始时间"
          :type="dateTimePicker.type"
          :value-format="dateTimePicker.valueFormat"
          :format="dateTimePicker.displayFormat"
          :class="{ 'required-hint': !result }"
        ></el-date-picker>
        <span style="margin: 0 2px;">—</span>
        <date-popover
          v-if="['半年度', '季度'].includes(condition.timeType)"
          :date="timeQuery.endTime"
          placeholder="选择结束时间"
          @change="changeTimeQuery('endTime', $event)"
          :time-type="condition.timeType"
          :class="{ 'required-hint': !result }"
        ></date-popover>
        <el-date-picker
          v-else
          v-model="timeQuery.endTime"
          clearable
          placeholder="选择结束时间"
          :type="dateTimePicker.type"
          :value-format="dateTimePicker.valueFormat"
          :format="dateTimePicker.displayFormat"
          :class="{ 'required-hint': !result }"
        ></el-date-picker>
      </div>
    </div>
    <div v-else-if="condition.regionType === 'fast-interval'" class="fast-interval">
      <span class="condition-name">{{ condition.name }}</span>
      <el-select
        v-model="timeQuery.region"
        placeholder="请选择"
        clearable
        class="condition-region"
        @change="getTime"
        :class="{ 'required-hint': !result }"
      >
        <el-option
          v-for="item in regionTypesInfo"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="condition-interval">
        <date-popover
          v-if="['半年度', '季度'].includes(condition.timeType)"
          :date="timeQuery.beginTime"
          placeholder="选择开始时间"
          @change="changeTimeQuery('beginTime', $event)"
          :time-type="condition.timeType"
          :disabled="timeQuery.region !== '自定义'"
          :class="{ 'required-hint': !result }"
          style="margin: 4px 0"
        ></date-popover>
        <el-date-picker
          v-else
          v-model="timeQuery.beginTime"
          clearable
          placeholder="选择开始时间"
          :disabled="timeQuery.region !== '自定义'"
          :type="dateTimePicker.type"
          :value-format="dateTimePicker.valueFormat"
          :format="dateTimePicker.displayFormat"
          :class="{ 'required-hint': !result }"
          style="margin: 4px 0"
        ></el-date-picker>
        <span style="margin: 0 2px;">—</span>
        <date-popover
          v-if="['半年度', '季度'].includes(condition.timeType)"
          :date="timeQuery.endTime"
          placeholder="选择结束时间"
          @change="changeTimeQuery('endTime', $event)"
          :time-type="condition.timeType"
          :disabled="timeQuery.region !== '自定义'"
          :class="{ 'required-hint': !result }"
        ></date-popover>
        <el-date-picker
          v-else
          v-model="timeQuery.endTime"
          clearable
          placeholder="选择结束时间"
          :disabled="timeQuery.region !== '自定义'"
          :type="dateTimePicker.type"
          :value-format="dateTimePicker.valueFormat"
          :format="dateTimePicker.displayFormat"
          :class="{ 'required-hint': !result }"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
import {
  regionTypeMap,
  timeTypeList
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import { regionTypes, compareMethodMap } from "@/views/Backend/Admin/Statistics/static"
import BaseButton from "@/components/UIComponents/Button"
import dj from "dayjs"
import DatePopover from "@/components/BaseComponents/DatePopover"
let quarterOfYear = require("dayjs/plugin/quarterOfYear")
dj.extend(quarterOfYear)
export default {
  name: "timeDisplay",
  components: { DatePopover, BaseButton },
  props: {
    condition: Object
  },
  data() {
    return {
      regionTypeMap,
      timeTypeList,
      regionTypes,
      compareMethodMap,
      timeQuery: {
        time: "",
        region: "",
        beginTime: "",
        endTime: ""
      },
      result: true
    }
  },
  computed: {
    regionTypesInfo() {
      return this.regionTypes.filter(region => this.condition.regions?.includes(region.value))
    },
    dateTimePicker() {
      const timeTypeMap = this._.keyBy(this.timeTypeList, "value")
      let timeTypeItem = timeTypeMap[this.condition.timeType]
      return {
        type: timeTypeItem.controlType,
        valueFormat: timeTypeItem.displayFormat, // value的格式
        djFormat: timeTypeItem.djFormat, // dayjs的格式
        displayFormat: timeTypeItem.displayFormat // 日期输入框实际展示的格式
      }
    },
    djFormat() {
      return this.timeTypeList.find(type => this.condition.timeType === type.value).djFormat
    },
    unit() {
      let result = ""
      switch (this.condition.timeType) {
        case "年":
          result = "year"
          break
        case "半年度":
        case "季度":
        case "年月":
          result = "month"
          break
        case "年月日":
          result = "day"
          break
        case "年月日时分":
          result = "minute"
          break
        case "年月日时分秒":
          result = "second"
          break
      }
      return result
    },
    counts() {
      let result = 1
      const isCustom =
        this.condition.regionType !== "fast-interval" ||
        (this.condition.regionType === "fast-interval" && this.timeQuery.region === "自定义")
      switch (this.condition.timeType) {
        case "半年度":
          if (isCustom) result = 6
          break
        case "季度":
          if (isCustom) result = 3
          break
        default:
          result = 1
          break
      }
      return result
    }
  },
  watch: {
    condition: {
      handler() {
        this.initData()
      },
      deep: true,
      immediate: true
    },
    timeQuery: {
      handler() {
        this.$emit("getVerifyResult")
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initData() {
      // 有时候内容没刷新，待调试
      if (["equal", "begin", "end"].includes(this.condition.regionType)) {
        switch (this.condition.defaultVal?.dateType) {
          case "Custom":
            this.timeQuery.time = this.condition.defaultVal?.value
            break
          case "Now":
            this.timeQuery.time = this.timeCompute(this.condition.defaultVal, new Date())
            break
        }
      }
      if (this.condition.regionType === "interval") {
        switch (this.condition.defaultVal?.dateType) {
          case "Custom":
            this.timeQuery.beginTime = this.condition.defaultVal?.beginTime
            this.timeQuery.endTime = this.condition.defaultVal?.endTime
            break
          case "Now":
            this.timeQuery.beginTime = this.timeCompute(
              this.condition.defaultVal?.begin,
              new Date()
            )
            this.timeQuery.endTime = this.timeCompute(this.condition.defaultVal?.end, new Date())
            break
        }
      }
      if (this.condition.regionType === "fast-interval") {
        this.timeQuery.region = this.condition.defaultVal?.value
        this.getTime(this.condition.defaultVal?.value)
      }
    },
    timeCompute(defaultVal, time) {
      if (!time) return ""
      let unit = defaultVal?.optionType?.split("-")[0]
      if (defaultVal?.optionType?.split("-")[1] === "ago") {
        time = dj(time).subtract(defaultVal?.number || 0, unit)
      } else {
        time = dj(time).add(defaultVal?.number || 0, unit)
      }
      return time.format(this.djFormat)
    },
    fastIntervalCompute(value, time) {
      let result = {}
      let unit = value.split("-")[1]
      let method = value.split("-")[0]
      switch (method) {
        case "last":
          time = dj(time).subtract(1, unit)
          break
        case "next":
          time = dj(time).add(1, unit)
          break
      }
      if (unit === "week") {
        result.beginTime = dj(time)
          .startOf(unit)
          .add(1, "day")
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .add(1, "day")
          .format(this.djFormat)
      } else {
        result.beginTime = dj(time)
          .startOf(unit)
          .format(this.djFormat)
        result.endTime = dj(time)
          .endOf(unit)
          .format(this.djFormat)
      }
      return result
    },
    getTime(val) {
      if (["自定义", "", undefined].includes(val)) {
        this.timeQuery.beginTime = ""
        this.timeQuery.endTime = ""
      } else {
        let timeInfo = this.fastIntervalCompute(val, new Date())
        this.timeQuery.beginTime = timeInfo.beginTime
        this.timeQuery.endTime = timeInfo.endTime
      }
    },
    changeTime(from) {
      if (!this.timeQuery.time) return
      let result = ""
      switch (from) {
        case "last":
          result = dj(this.timeQuery.time).subtract(this.counts, this.unit)
          break
        case "next":
          result = dj(this.timeQuery.time).add(this.counts, this.unit)
          break
      }
      this.timeQuery.time = dj(result).format(this.djFormat)
    },
    getTimeFilters(chart) {
      let filters = []
      switch (this.condition.regionType) {
        case "equal":
          if (this.timeQuery.time) {
            filters = filters.concat(this.getEqualPointFilter(chart))
          }
          break
        case "begin":
        case "end":
          if (this.timeQuery.time) {
            filters = filters.concat(this.getPointFilter(chart))
          }
          break
        case "interval":
        case "fast-interval":
          if (this.timeQuery.beginTime || this.timeQuery.endTime) {
            filters = filters.concat(this.getInterValFilter(chart))
          }
      }
      return filters
    },
    getEqualPointFilter(chart) {
      return [this.getFilter(chart, "equal", "begin"), this.getFilter(chart, "equal", "end")]
    },
    getPointFilter(chart) {
      let pointFilter = {}
      pointFilter = this.getFilter(chart, "point", this.condition.regionType)
      return [pointFilter]
    },
    getInterValFilter(chart) {
      return [this.getFilter(chart, "interval", "begin"), this.getFilter(chart, "interval", "end")]
    },
    getFilter(chart, from, type) {
      let filter = {}
      filter.compareMethod = this.compareMethodMap[type]
      filter.key = chart.controlId
      filter.type = "time"
      filter.value = null
      let item = {}
      if (["equal", "point"].includes(from)) {
        switch (type) {
          case "begin":
            item = { value: this.getStart(this.timeQuery.time) }
            break
          case "end":
            item = { value: this.getEnd(this.timeQuery.time) }
            break
        }
      } else {
        switch (type) {
          case "begin":
            item = { value: this.getStart(this.timeQuery.beginTime) }
            break
          case "end":
            item = { value: this.getEnd(this.timeQuery.endTime) }
            break
        }
      }
      item.var = false
      filter.varItems = [item]
      return filter
    },
    getStart(time) {
      if (["year", "month", "day"].includes(this.unit)) {
        return dj(time)
          .startOf(this.unit)
          .format("YYYY-MM-DD HH:mm:ss")
      } else if (this.unit === "minute") {
        return time + ":00"
      } else {
        return time
      }
    },
    getEnd(time) {
      if (["year", "month", "day"].includes(this.unit)) {
        return dj(time)
          .add(this.counts - 1, this.unit)
          .endOf(this.unit)
          .format("YYYY-MM-DD HH:mm:ss")
      } else if (this.unit === "minute") {
        return time + ":59"
      } else {
        return time
      }
    },
    getVerify() {
      let result = true
      if (["equal", "begin", "end"].includes(this.condition.regionType)) {
        if (this._.isEmpty(this.timeQuery.time)) result = false
      }
      if (this.condition.regionType === "interval") {
        if (this._.isEmpty(this.timeQuery.beginTime) && this._.isEmpty(this.timeQuery.endTime))
          result = false
      }
      if (this.condition.regionType === "fast-interval") {
        if (this.timeQuery.region) {
          if (this.timeQuery.region === "自定义") {
            if (this._.isEmpty(this.timeQuery.beginTime) && this._.isEmpty(this.timeQuery.endTime))
              result = false
          }
        } else {
          result = false
        }
      }
      this.result = result
      return result
    },
    changeTimeQuery(from, val) {
      switch (from) {
        case "point":
          this.timeQuery.time = val
          break
        case "beginTime":
          this.timeQuery.beginTime = val
          break
        case "endTime":
          this.timeQuery.endTime = val
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.time-display {
  .time-point {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .condition-region {
      margin: 0 3px;
    }
    .operation {
      margin: 4px 0 4px 10px;
      display: flex;
      .left {
        border-bottom-right-radius: unset;
        border-top-right-radius: unset;
        border-right: unset;
      }
      .right {
        border-bottom-left-radius: unset;
        border-top-left-radius: unset;
      }
      .base-button {
        width: 33px;
        padding: 5px 3px;
      }
      .el-button + .el-button {
        margin-left: 0;
      }
    }
  }
  .interval {
    display: flex;
    align-items: center;
    .condition-name {
      margin-right: 10px;
    }
  }
  .fast-interval {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .condition-name {
      margin-right: 10px;
    }
    .condition-region {
      width: unset;
      margin-right: 10px;
    }
    .condition-interval {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .required-hint {
    ::v-deep {
      .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
}
</style>
